export function isRichHtmlValue(value, format) {
  if (format === 'html') return true;
  return Boolean(value && /<[a-z][\s\S]*>/i.test(String(value)));
}

export function plainTextToEditorHtml(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '<p><br></p>';
  if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
  const esc = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  const parts = esc.split(/\n+/).filter(Boolean);
  if (parts.length === 0) return '<p><br></p>';
  return parts.map((line) => `<p>${line}</p>`).join('');
}

export function richHtmlIsEmpty(value) {
  if (!value) return true;
  const text = String(value)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
  return !text;
}
